import { useEffect, useState } from 'react';

const TARGET_TIME = Date.UTC(2026, 5, 11, 19, 0, 0); // 12/06/2026 02:00 GMT+7 = 11/06/2026 19:00 UTC

const CountDownFinal = () => {
  const calculateTimeLeft = () => {
    const now = Date.now();
    const diff = TARGET_TIME - now;

    if (diff <= 0) {
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
        finished: true
      };
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => n.toString().padStart(2, '0');

    return {
      days: pad(days),
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
      finished: false
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (timeLeft.finished) {
    return (
      <div className="inline-flex flex-col items-center justify-center px-3 py-2 rounded-[14px] bg-[#fff] border border-[#26A9E0] shadow-[0_0_10px_rgba(0,0,0,0.45)]">
        <span className="text-[14px] md:text-[16px] font-medium text-[#26A9E0] uppercase tracking-wide">
          Vòng chung kết đang diễn ra
        </span>
      </div>
    );
  }

  return (
    <div className="inline-flex gap-[9px] md:gap-[11px] items-center">
      {/* Days */}
      <div className="bg-[#26a9e0] flex flex-col h-[46px] md:h-[54px] items-center justify-center rounded-[6px] md:rounded-[7px] w-[51px] md:w-[60px] text-white uppercase text-center">
        <p className="font-black text-[27px] md:text-[32px] leading-none m-0">{timeLeft.days}</p>
        <p className="font-bold text-[9px] md:text-[11px] leading-none m-0 mt-[-3px]">Ngày</p>
      </div>

      {/* Hours */}
      <div className="bg-[#d7f3ff] flex flex-col h-[46px] md:h-[54px] items-center justify-center rounded-[6px] md:rounded-[7px] w-[51px] md:w-[60px] text-[#26a9e0] uppercase text-center">
        <p className="font-black text-[27px] md:text-[32px] leading-none m-0">{timeLeft.hours}</p>
        <p className="font-bold text-[9px] md:text-[11px] leading-none m-0 mt-[-3px]">giờ</p>
      </div>

      {/* Minutes */}
      <div className="bg-[#d7f3ff] flex flex-col h-[46px] md:h-[54px] items-center justify-center rounded-[6px] md:rounded-[7px] w-[51px] md:w-[60px] text-[#26a9e0] uppercase text-center">
        <p className="font-black text-[27px] md:text-[32px] leading-none m-0">{timeLeft.minutes}</p>
        <p className="font-bold text-[9px] md:text-[11px] leading-none m-0 mt-[-3px]">phút</p>
      </div>

      {/* Seconds */}
      <div className="bg-[#d7f3ff] flex flex-col h-[46px] md:h-[54px] items-center justify-center rounded-[6px] md:rounded-[7px] w-[51px] md:w-[60px] text-[#26a9e0] uppercase text-center">
        <p className="font-black text-[27px] md:text-[32px] leading-none m-0">{timeLeft.seconds}</p>
        <p className="font-bold text-[9px] md:text-[11px] leading-none m-0 mt-[-3px]">giây</p>
      </div>
    </div>
  );
};

export default CountDownFinal;
